import React from 'react';
import LazyloadImage from '../../../../generic/Utils/LazyloadImage';

const SideBarLogo = ({logoData}) => {

  const redirectToProgramHome = (e) => { 
    if(Navigation.isClickEvent(e)) {
      e.preventDefault();
      window.location = logoData.url 
    }
  }

  const innerContentForIcon = () => {
    return (
      <i className="fa-solid fa-4x fa-circle text-muted fa-fw m-r-xs" content={logoData.icon_content} tabIndex={0} onClick={(e)=> redirectToProgramHome(e)} onKeyDown={(e) => redirectToProgramHome(e)}>{logoData.icon_content}</i>
    )
  }

  const innerContentForImage = () => {
    const hasWebpImage = !!logoData["webp_optimized_image_url"];

    const imgTag = (
      <LazyloadImage
        source={ logoData.image_url }
        alt={ logoData.image_options.alt }
        style={ {
          width: logoData.image_options.width,
          height: logoData.image_options.height,
          objectFit: "cover"
        } }
        tabIndex={ 0 }
        onClick={ (e)=> redirectToProgramHome(e) }
        onKeyDown={ (e) => redirectToProgramHome(e) }
        onError={ hasWebpImage ? (event) => PictureTagHelper.onError(event, `${logoData.image_url}`) : '' }
      />
    );

    if (hasWebpImage) {
      return (
        <picture>
          <source data-srcset={logoData.webp_optimized_image_url} type="image/webp" />
          {imgTag}
        </picture>
      )
    } else {
      return imgTag;
    }
  }

  return (
    <React.Fragment>
      <div className='p-md'>
        { logoData.isIcon ? innerContentForIcon() : innerContentForImage() }
      </div>
    </React.Fragment>
  )
}

export default SideBarLogo;
